import * as React from "react";
interface Props {
  containerWidth?: number;
  viewportWidth?: number;
}
const height = 16;
function Ruler(props: Props) {
  const {
    containerWidth = 0,
    viewportWidth = 0
  } = props;
  return <svg viewBox={`-${containerWidth / 2} ${-height / 2} ${containerWidth} ${height}`} className={"ssl4j8q"}>
      <rect x={-containerWidth / 2} y={-height / 2} width={containerWidth} height={height} fill="var(--timvir-secondary-background-color)" />

      <line x1={-viewportWidth / 2} x2={-viewportWidth / 2} y1={-height / 2} y2={height / 2} strokeWidth={2} stroke="var(--timvir-text-color)" />
      <line x1={viewportWidth / 2} x2={viewportWidth / 2} y1={-height / 2} y2={height / 2} strokeWidth={2} stroke="var(--timvir-text-color)" />
    </svg>;
}
export default Ruler;

require("./Ruler.linaria.module.css!=!../../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Ruler.tsx");